module.exports = __webpack_public_path__ + "static/media/thumb-1920-548302.a7a64390.jpg";